import { UpdateAgentQuery } from "@/api/graphql/agents/update/mutations";
import { getGraphqlClient } from "@/api/graphql/client.ts";
import { AccountsMsUpdateSupportUserRequest } from "@/api/graphql/types/graphql.ts";

export const updateAgentMutation = async (
  request: AccountsMsUpdateSupportUserRequest,
) => await getGraphqlClient().request(UpdateAgentQuery, { request });
